import { useState } from "react";
import IFaq from "../../../../interfaces/faq";
import IValidationObject from "../../../../interfaces/validationObject";


const useFAQValidation = (faq: IFaq) => {
    const [validationObject, setValidationObject] = useState<IValidationObject[]>([
        { name: "question", isValid: true, validationMessage: "" },
        { name: "answer", isValid: true, validationMessage: "" }
    ])
    const [isValidationPassed, setIsValidationPassed] = useState<boolean>(true)

    const validateInputs = (): boolean => {

        let tempValidationObject: IValidationObject[] = [
            { name: "question", isValid: true, validationMessage: "" },
            { name: "answer", isValid: true, validationMessage: "" }
        ]

        let tempIsValidationPassed = true

        const setFailedValidation = (name, message) => {
            tempIsValidationPassed = false
            tempValidationObject.forEach(element => {
                if (element.name === name) {
                    element.isValid = false
                    element.validationMessage = message
                }
            });
        }

        if (faq.question === "" || typeof (faq.question) === "undefined") {
            setFailedValidation("question", "Please enter a question.")
        }

        if (faq.answer === "" || typeof (faq.answer) === "undefined") {
            setFailedValidation("answer", "Please enter an answer.")
        }

        setValidationObject(tempValidationObject)
        setIsValidationPassed(tempIsValidationPassed)
        return tempIsValidationPassed
    }

    const getValidation = (name): IValidationObject => {
        let returnValue: IValidationObject = {} as IValidationObject
        validationObject.forEach(element => {
            if (name === element.name) {
                returnValue = element
            }
        });
        return returnValue
    }

    return {
        validationObject,
        setValidationObject,
        isValidationPassed,
        setIsValidationPassed,
        validateInputs,
        getValidation
    }
}

export default useFAQValidation